<template lang="pug">
div(class='timeline_konva__container' ref='container')
  v-stage(ref='stage' :config='{ width: width, height: 60 }')
    v-layer(ref='layer-history')
      v-group(v-for='color, index in colors' :key='index')
        v-rect(
          :config=`{
            x: getX(color.fromTs),
            y: 0,
            width: getWidthColorUrl(color),
            height: 60,
            fill: color.color
          }`)
    v-layer(ref='layer-archive')
      v-group(v-for='timeline, index in timelines' :key='index')
        v-rect(
          :config=`{
            x: getX(timeline.start),
            y: 0,
            width: getWidth(timeline.duration),
            height: 60,
            fill: "#1B5E20"
          }`)
    v-layer(ref='layer-motions')
      v-group(v-for='motion, index in motions' :key='index')
        v-rect(
          :config=`{
            x: getX(motion.start),
            y: 0,
            width: getWidth(motion.duration),
            height: 60,
            fill: "#FFA000",
          }`)
</template>

<script>
import optimizedResize from "@/core/helpers/optimizedResize";

export default {
  name: "Timeline",
  props: {
    beginTime: {
      type: Number,
      default: new Date().setHours(0, 0, 0, 0) / 1000,
    },
    timezone: {
      type: Number,
      default: 7,
    },
    timelines: {
      type: Array,
      default: () => [],
    },
    motions: {
      type: Array,
      default: () => [],
    },
    colors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      width: 0,
      timer: null,
    };
  },
  computed: {
    zipTime() {
      return (3600 * 24) / this.width;
    },
    timezoneOffset() {
      return new Date().getTimezoneOffset() / 60 + this.timezone
    },
  },
  mounted() {
    this.getStyleWidth();
    optimizedResize.add(() => {
      this.getStyleWidth();
    });
  },
  destroyed() {
    clearInterval(this.timer);
    optimizedResize.remove();
  },
  methods: {
    /**
     * @param {Number} start
     */
    getX(start) {
      return (start - this.$props.beginTime + (this.timezoneOffset * 3600000) / 1000) / this.zipTime;
    },
    /**
     * @param {String} stream
     */
    getColorStream (name) {
      let color = '#1B5E20'
      this.$props.colors.map((item) => {
        if (item.name === name) {
          color = `hsl(${item.color.h}, ${item.color.s}%, ${item.color.l}%)`
        }
      })
      return color
    },
    getStyleWidth() {
      const konvaContent = this.$refs.container;

      this.width = konvaContent.offsetWidth;
    },

    getWidth(duration) {
      return duration / this.zipTime;
    },

    getWidthColorUrl(color) {
      return (color.toTs - color.fromTs) / this.zipTime;
    },
  },
};
</script>

<style lang="postcss">
.timeline_konva__container {
  background-color: #282828;
}
</style>
